import React, {useRef, useState, useEffect } from 'react';
import { Row, Col, Card, Button, Form } from 'react-bootstrap';
import classNames from 'classnames';
import Flex from '../../common/Flex';
import {edit, listLicense} from '../../../lib/api/coach';

export function Edit({ initialData, onClose, onSave }) {
  const [coach, setCoach] = useState(initialData);
  const [errors, setErrors] = useState({
    name: false,
    last_name: false,
    license_type_id: false,
    license: false,
  });

  const [license, setLicense] = useState([]);
  const [previewImage, setPreviewImage] = useState(null);

  const user =  JSON.parse(localStorage.getItem('user'));

  console.log('coach.document_guid',coach.document_guid)
  const fileInputRef = useRef(null);

  useEffect(() => {
    (async () => {
      const resLicense = await listLicense();
      setLicense(resLicense);

      if (coach?.document_guid) {
        setPreviewImage(process.env.REACT_APP_BASE_API_URL +`/uploads/${coach.image_path}`);
      }
    })();
  }, [coach.document_guid]);



  const handelInput = e => {
    const { name, value } = e.target;
    setCoach({ ...coach, [name]: value });
  };

  const handleSubmit = async event => {
    event.preventDefault();
    if (!validateForm(event)) return;

    const form = event.currentTarget;
    const _data = {
      name: form.name.value,
      last_name: form.last_name.value,
      address: form.address.value,
      license_type_id: form.license_type_id.value,
      license: form.license.value,
      descreption: form.descreption.value
    };

    const formData = new FormData(event.currentTarget);
    //formData.append('descreption', '');

    await edit(Object.fromEntries(formData.entries()), coach.document_guid);

    //await edit(_data, coach.document_guid);
    onSave();
    onClose();
  };

  const handleImageChange = e => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setPreviewImage(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const validateForm = event => {
    const form = event.currentTarget;
    const newErrors = {
      name: !form.name.value.trim(),
      last_name: !form.last_name.value.trim(),
      license_type_id: !form.license_type_id.value,
      license: !form.license.value
    };
    setErrors(newErrors);

    if (Object.values(newErrors).some(error => error)) {
      event.stopPropagation();
      return false;
    }
    return true;
  };

  return (
      <Card>
        <Card.Body className="bg-body-tertiary">
          <Form
              method="PUT"
              encType="multipart/form-data"
              noValidate
              onSubmit={handleSubmit}
          >
            <Row className="mb-3">
              <Col md="6">
                <Form.Label>Slika</Form.Label>
                <div
                    onClick={() => fileInputRef.current?.click()}
                    style={{
                      cursor: 'pointer',
                      width: 120,
                      height: 120,
                      borderRadius: '50%',
                      overflow: 'hidden',
                      border: '2px dashed #ccc',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                >
                  {previewImage ? (
                      <img
                          src={previewImage}
                          alt="Preview"
                          onError={(e) => {
                            e.target.onerror = null; // spreči loop ako fallback ne postoji
                            if (!e.target.dataset.fallbackTried) {
                              e.target.src = process.env.REACT_APP_BASE_API_URL +'/uploads/blank.jpg';
                              e.target.dataset.fallbackTried = 'true';
                            }
                          }}
                          style={{width: '100%', height: '100%', objectFit: 'cover'}}
                      />
                  ) : (
                      <span className="text-muted">Klikni za sliku</span>
                  )}
                </div>
                <Form.Control
                    type="file"
                    name="image"
                    accept="image/*"
                    style={{display: 'none'}}
                    ref={fileInputRef}
                    onChange={handleImageChange}
                />
              </Col>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} md="12" controlId="name">
                <Form.Label>Ime</Form.Label>
                <Form.Control
                    required
                    type="text"
                    name="name"
                    value={coach.name || ''}
                    onChange={handelInput}
                    isInvalid={errors.name}
                />
                <Form.Control.Feedback type="invalid">Molimo unesite ime.</Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} md="12" controlId="last_name">
                <Form.Label>Prezime</Form.Label>
                <Form.Control
                    required
                    type="text"
                    name="last_name"
                    value={coach.last_name || ''}
                    onChange={handelInput}
                    isInvalid={errors.last_name}
                />
                <Form.Control.Feedback type="invalid">Molimo unesite prezime.</Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} md="6" controlId="address">
                <Form.Label>Adresa</Form.Label>
                <Form.Control required type="text" name="address" value={coach.address || ''}  onChange={handelInput} isInvalid={errors.address} />
                <Form.Control.Feedback type="invalid">Molimo unesite adresu.</Form.Control.Feedback>
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} md="6" controlId="license_type_id">
                <Form.Label>Nivo licence</Form.Label>
                <Form.Select name="license_type_id" value={coach.license_type_id || ''} onChange={handelInput}	isInvalid={errors.license_type_id} disabled={!!user.club_guid} >
                  <option value="">Izaberite</option>
                  {license.map(p => <option key={p.license_type_id} value={p.license_type_id}>{p.name}</option>)}
                </Form.Select>
                <Form.Control.Feedback type="invalid">Molimo unesite nivo licence.</Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md="6" controlId="license">
                <Form.Label>Broj licence</Form.Label>
                <Form.Control required type="text" name="license" value={coach.license || ''}  onChange={handelInput} isInvalid={errors.license} disabled={!!user.club_guid} />
                <Form.Control.Feedback type="invalid">Molimo unesite licencu.</Form.Control.Feedback>
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group className="mb-3" controlId="descreption">
                <Form.Label>Opis</Form.Label>
                <Form.Control as="textarea" name="descreption" rows={3}  value={coach.descreption || ''}  onChange={handelInput}/>
              </Form.Group>
            </Row>
            <Button type="submit">Sačuvaj</Button>
          </Form>
        </Card.Body>
      </Card>
  );
}
